import { ButtonIcon, ConfirmationDialog } from '@statsbomb/kitbag-components';
import { _VideoPlayer } from '@statsbomb/video-client-js';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';

const Container = styled.div`
  min-width: 50vw;
`;

export function PreviewPlayer({ key, title: providedTitle, size, url }) {
  const intl = useIntl();

  const [src, setSrc] = useState();

  const [isShowPreview, setIsShowPreview] = useState(false);

  const title =
    providedTitle ||
    intl.formatMessage({
      defaultMessage: 'Video Preview',
      id: '40814',
    });

  const showPreview = () => {
    setIsShowPreview(true);
  };

  const handleClose = () => setIsShowPreview(false);

  useEffect(() => {
    setSrc(url);
  }, [key]);

  return (
    <>
      <ButtonIcon
        icon="Play"
        onClick={showPreview}
        size={size}
        title={title}
        variant="secondary"
      />
      <ConfirmationDialog
        cancelLabel={null}
        confirmLabel={intl.formatMessage({
          defaultMessage: 'Close',
          id: 'd3d2e',
        })}
        id={`preview-${url}`}
        isOpen={isShowPreview}
        onEscape={handleClose}
        onCancel={handleClose}
        onConfirm={handleClose}
        title={title}
      >
        {isShowPreview && (
          <Container>
            {/* Disabled as known prefix for dev only internal components */}
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <_VideoPlayer src={src} autoPlay />
          </Container>
        )}
      </ConfirmationDialog>
    </>
  );
}

PreviewPlayer.propTypes = {
  key: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
};

PreviewPlayer.defaultProps = {
  key: undefined,
  size: undefined,
  title: undefined,
};

export default { PreviewPlayer };
